import React, {useEffect, useState, useRef} from "react";
import Constants from "../Utilities/Constants";
import axios from "axios";
import { Modal } from "react-bootstrap";
import { absolutizeImageSrcs } from "../Utilities/pageContent";


const Popup =  ({furl}) => {
    const [page, setPage] = useState({});
    const isMounted = useRef(false);
    const [showModal, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

    useEffect(() => {

        if (!isMounted.current) {

            const fetchPage = async () => {
            
                try {
                    var url = `${Constants.API_URL_GET_PAGE}/${furl}`;
                    const response = await axios.get(url);
                    setPage(response.data);
                } 
                catch (error) {
                    alert("לא ניתן להתחבר לשרת");
                }
            };

            fetchPage();

            return () => {
                isMounted.current = true;
            }
        } 

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (sessionStorage.getItem('popupShown')) return;
        setTimeout(() => {
            handleShow();
            sessionStorage.setItem('popupShown', '1');
        }, 1000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
            
        <Modal className="p-3" fade="true" centered show={showModal} onHide={handleClose}>
            <Modal.Body> 
                <img src={`${Constants.IMAGE_URL}/${page.pageImage}`} alt={page.pageTitle} className="w-100" />
                <div className="fw-bold mt-3">
                    <div dangerouslySetInnerHTML={{ __html: absolutizeImageSrcs(page.pageContent) }} />
                </div>
            </Modal.Body>
            <button type="button" className="fancybox-close-small" onClick={handleClose} > </button>
        </Modal>
    );
}

export default Popup;
